// export const PORT = "answer/"
export const PORT = "merckyzd/"
// 开发环境
// export const PROJECT_PATH = `http://24099289.nat123.cc:8080/${PORT}`;
// export const PROJECT_PATH = `http://192.168.10.16:12301/${PORT}`;

// 老环境
// export const PROJECT_PATH = `https://yzd-test.merck.cn/${PORT}`;



// export const PROJECT_PATH = `https://ereach.ibugoo.cn/${PORT}`;
// export const PROJECT_PATH = `http://digital.consultech.com.cn:82/index.php?s=/w4`;

// 测试环境
export const PROJECT_PATH = `https://wechatart-test.merckgroup.com.cn/weiphp_moke/index.php?s=/w6`;

// 生产环境
// export const PROJECT_PATH = `https://wechatart.merckgroup.com.cn/weiphp_moke/index.php?s=/w6`;

// export const PROJECT_PATH = `http://yzdh5.ibugoo.cn/index.php?s=/w6`;
export const IMAGES_PATH = 'https://oss.consultech.com.cn/mkyzd';
export const IMAGES_URL = 'https://consultech-bucket.oss-cn-shanghai.aliyuncs.com/mwanswer/';

export const ERR_OK = 1000;
// 发送请求需Token
export const ACCESS_TOKEN = ''// uni.getStorageSync('userToken');
// loading
export function loadingTip({
	title = "加载中",
	icon = "loading",
	image = "",
	duration = 3000,
	mask = false,
	success
}) {
	wx.showToast({
		title: title,
		icon: icon,
		image: image,
		mask: mask,
		duration: duration,
		success: success
	})
}
//网络状态监听
export function network() {
	//网络状态
	uni.getNetworkType({
		success: function(res) {
			// 返回网络类型, 有效值：
			// wifi/2g/3g/4g/unknown(Android下不常见的网络类型)/none(无网络)
			let networkType = res.networkType;
			networkType == 'none' ? loadingTip({
				title: `请检查您的网络状态`,
				icon: "none",
				duration: 1000
			}) : ""
		}
	})
	//网络状态监听
	uni.onNetworkStatusChange(function(res) {
		let isConnected = res.isConnected;
		isConnected ? loadingTip({
			title: `目前网络状态为${res.networkType}`,
			icon: "none",
			duration: 1000
		}) : loadingTip({
			title: `请检查您的网络状态`,
			icon: "none",
			duration: 1000
		});

	})
}


//获取宽高
export var screenState = function() {
	try {
		let getEquipment = uni.getStorageSync("equipment");
		if (!getEquipment) {
			let state = uni.canIUse('getSystemInfoSync.return.screenWidth');
			if (state) {
				var res = uni.getSystemInfoSync();
				uni.setStorageSync("equipment", res)
				return res
			} else {
				// loadingTip({
				// 	title: "不支持获取",
				// 	icon: "none"
				// })
			}
		} else {
			// return getEquipment
			let state = uni.canIUse('getSystemInfoSync.return.screenWidth');
			if (state) {
				var res = uni.getSystemInfoSync();
				uni.setStorageSync("equipment", JSON.stringify(res));
				return res
			} else {
				// loadingTip({
				// 	title: "不支持获取",
				// 	icon: "none"
				// })
			}
		}


	} catch (err) {
		// loadingTip({
		// 	title: "不支持获取",
		// 	icon: "none"
		// })
	}
}

export const windowWidth = screenState()?screenState().windowWidth:'';
export const windowHeight = screenState() ? screenState().windowHeight : '';
export const pixelRatio = screenState() ? screenState().pixelRatio : '';

//随机数组
function shuffle(arr) {
	return arr.sort(function() {
		return Math.random() - 0.5;
	});
}

//打分规则
export function scoringRules(timer, ruleList, extent) {
	let obj = {},
		ruleItems = [],
		count = 100,
		isIndex = 0;
	ruleList.map((item, index, arr) => {
		obj = {};
		obj["timer"] = item.mjlx.split("_")[0];
		obj["score"] = item.mjlx.split("_")[1];
		ruleItems.push(obj)
	})
	count = ruleItems[0]["score"] * extent;
	// item.timer <= COUNT_DOWN - timer && 
	ruleItems.map((item, index, arr) => {

		if (index == 0) {
			if (item.timer >= COUNT_DOWN - timer) {
				isIndex = index
			}
		} else if (COUNT_DOWN - timer > arr[index - 1].timer && COUNT_DOWN - timer <= item.timer) {
			isIndex = index
		}
	})
	return {
		count: count,
		rules: parseInt(ruleItems[isIndex].score)
	};
}

// export const windowWidth = '';
// export const windowHeight = '';
// export const pixelRatio = '';
export const SERIAL_NUMBER = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
export const COUNT_DOWN = 20;
export const MIN_COUNT_DOWN = 0;
export const aswardLists = [{
		'backgroundColor': "#E52F8B",
		"color": "#eee"
	},
	{
		'backgroundColor': "#009251",
		"color": "#005BAC"
	},
	{
		"backgroundColor": "#A9CE1F",
		"color": "#eee"
	},
	{
		'backgroundColor': "#21B8CD",
		"color": "#005BAC"
	},
	{
		'backgroundColor': "#E52F8B",
		"color": "#eee"
	},
	{
		'backgroundColor': "#FEE2BA",
		"color": "#005BAC"
	},
	{
		'backgroundColor': "#A3D7D5",
		"color": "#005BAC"
	},
	{
		'backgroundColor': "#E7C9D1",
		"color": "#005BAC"
	}
]
export const TITLE = ["答题王", "知识大咖", "熟手", '隐士', ];
export const RANDOM_TEXT = [{
	title: "别急，",
	name: "我还要再值个班"
}, {
	title: "等等，",
	name: "我再加个医嘱"
}, {
	title: "别拦我，",
	name: "我还能再收俩"
}, {
	title: "没事儿，",
	name: "我Hold住?"
}, {
	title: "        ",
	name: "不瘦10斤不换头像"
}, {
	title: "       ",
	name: "最热爱的就是工作"
}, {
	title: "考试？",
	name: "小case！学霸就是我！"
}, {
	title: "别拦我!",
	name: "我要发PAPER!"
}]
export const RANDOM_BG = [
	'./../../images/poster/egit.png',
	'./../../images/poster/five.png',
	'./../../images/poster/four.png',
	'./../../images/poster/ne_01.png',
	'./../../images/poster/one.png',
	'./../../images/poster/seven.png',
	'./../../images/poster/six.png',
	'./../../images/poster/three.png',
	'./../../images/poster/two.png'
]
//去重
export function deweight(data) {
	var res = [];
	var json = {};
	for (var i = 0; i < data.length; i++) {
		if (!json[data[i].questionId]) {
			res.push(data[i]);
			json[data[i].questionId] = 1;
		}
	}

	return res;
}


//隐私条款
export const CLAUSE = [{
		title: "介绍",
		content: "感谢您对默克ART助手(后简称默克)网站感兴趣。数据保护和保密是我们非常重视的问题，我们遵循有关国家层面的及欧洲的数据保护条例。本数据保护措施声明特告知我们可能收集的数据的类型以及我们如何使用这些数据。",
		children: [],
		content1: ""
	},
	{
		title: "数据存储和使用",
		content: "您将匿名访问网站。我们存储和分析的数据仅用于统计目的，例如确保服务的持续改进。在服务器上存储的数据包括互联网服务供应商的名称、您访问的网站和查找的默克网页、IP地址以及访问日期和持续时间。如果您使用具体服务则需要您的个人数据，包括但不仅限于姓名、电子邮件、确认密码、医院名称、科室名称、手机号码；如果您自愿明示同意，我们会使用您的数据：",
		children: [{
				content: "作为注册程序的一部分；"
			},
			{
				content: "当您注册并访问网站时验证您是医疗保健专业人员；"
			},
			{
				content: "通过填写表格或发送电子邮件订购产品或服务，向我们发送查询或请求资料；"
			},
			{
				content: "如果您同意收到此类更新，向您发送我们的通讯或有关我们产品、服务或网站的更新信息；"
			},
			{
				content: "通过下面的方式与您联系，要求您完成调查问卷或针对医学疾病及我们提供的健康信息的有用性进行市场调研，您也可不必回应；"
			},
			{
				content: "确保网站上的内容以最有效的方式在您的计算机上呈现；"
			},
			{
				content: "当您选择时，允许您参与我们服务的互动功能(如果有)。和/或；"
			},
			{
				content: "当网站有更新时通知您；"
			},
		],
		content1: ""
	},
	{
		title: "市场研究/调查",
		content: "如果我们希望进行以内部研究为目的调查或市场研究，我们可能会聘请独立的专业服务供应商，其唯一目的是为了进行此类调查或市场研究。这是为了保护受访者的匿名权，并确保研究无偏倚。 除非受到其他法律条款的约束，否则仅将您的个人资料用于您已经同意或在本隐私政策中声明的目的。 在提供您要求的服务或您已经同意的情况下，您的个人资料将仅由我们与第三方共享。如果数据已发布并被供默克子公司使用，并且如果涉及到其他国家的数据传输，默克将确保数据导入者处于适当的数据保护承诺级别。",
		children: [],
		content1: ""
	}, {
		title: "数据保留",
		content: "根据法定义务，在需要提供服务或在商定的时间段存储数据。",
		children: [],
		content1: ""
	}, {
		title: "有权审查、纠正和反对",
		content: "您有权查看和更正我们存储的任何个人数据，您可以随时撤消同意书，让我们停止使用您的数据，这会影响将来的所有运用。您只需发送电子邮件至privacy@merckgroup.com来完成。",
		children: [],
		content1: ""
	}, {
		title: "数据保护和安全",
		content: "参与数据处理的员工在使用个人资料时必须保密。我们的数据保护措施不断更新，也反映了技术发展。",
		children: [],
		content1: ""
	}, {
		title: "Adobe分析 (Omniture)",
		content: "本网站使用Adobe分析，由Adobe系统软件爱尔兰有限公司（“Adobe”）提供网站分析服务。Adobe分析使用“Cookie”，是将文本文件安置在您的计算机上，通过网站的整体流量模式进行网站分析。通过将关于网站使用的Cookie生成的信息发送给Adobe，设置确保在地理定位之前IP地址被匿名化，并且在存储之前将被通用IP地址替换。Adobe代表网站供应商，将使用此信息来评估您对网站的使用情况，为网站运营商编制网站活动报告，并提供与网站活动有关的其他服务和互联网使用信息。Adobe不会将您的IP地址与Adobe持有的任何其他数据相关联。 您可以通过在浏览器上选择适当的设置来拒绝使用用户识别。但是，请注意，如果您这样做，您可能无法使用网站的全部功能。此外，您可以通过下载和安装http://www.adobe.com/privacy/opt-out.html下的浏览器插件来防止Adobe收集和使用数据（Cookie和IP地址）。",
		children: [],
		content1: ""
	}, {
		title: "Cookie",
		conent: "Cookie是您所访问的网站安置在您计算机上的小文本文件。它们被广泛使用，有助于您访问或更有效地访问网站，并向网站所有者提供有关信息。您可以在下表中找到有关我们使用的各个Cookie的信息以及使用的目的：",
		children: [],
		content1: "您可以通过激活浏览器上的设置来阻止Cookie，通过这种方式您可拒绝所有或部分Cookie设置。但是，如果您使用浏览器设置为阻止所有Cookie(包括基本cookies)，您可能无法访问我们网站的全部或部分内容。要了解有关Cookie的更多信息，包括查看已设置的Cookie以及如何管理和删除Cookie，请访问www.allaboutcookies.org。"
	}, {
		title: "联系我们",
		content: "如果您有任何问题或建议，请随时联系我们公司的隐私主任。",
		children: [{
				title: "",
				content: "Norbert Moeren"
			},
			{
				title: "",
				content: "Merck KGaA公司隐私主任"
			},
			{
				title: "",
				content: "电话：+49615172-5167"
			},
			{
				title: "",
				content: "传真：+49615172-915167"
			},
			{
				title: "",
				content: "电子邮箱：privacy@merckgroup.com"
			},
			{
				title: "",
				content: "默克ART助手服务号由默克雪兰诺有限公司独立运营，定期推送默克生殖业务领域相关信息，不涉及默克医药健康集团的其他业务领域。"
			},
		],
		content1: ""
	}
]
